/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * authenticate
     * @param input input
     * @return OK
     */
    authenticateUsingPOST(input: ApiAuthenticateDto): Promise<ROfAuthenticateVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthenticateUsingPOST(_response);
        });
    }

    protected processAuthenticateUsingPOST(response: AxiosResponse): Promise<ROfAuthenticateVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAuthenticateVO.fromJS(resultData200) : new ROfAuthenticateVO();
            return result200;
        }
        return Promise.resolve<ROfAuthenticateVO>(<any>null);
    }

    /**
     * webDavAuthenticate
     * @param tenantId tenantId
     * @param userName userName
     * @return OK
     */
    webDavAuthenticateUsingGET(tenantId: string, userName: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/cas/token?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWebDavAuthenticateUsingGET(_response);
        });
    }

    protected processWebDavAuthenticateUsingGET(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * getOpenToken
     * @return OK
     */
    getOpenTokenUsingGET(): Promise<{ [key: string] : any; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth-open-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOpenTokenUsingGET(_response);
        });
    }

    protected processGetOpenTokenUsingGET(response: AxiosResponse): Promise<{ [key: string] : any; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : any; }>(<any>null);
    }

    /**
     * authorize
     * @param complete (optional) 
     * @param model (optional) model
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    authorizeUsingGET(complete: boolean | null | undefined, model: any | null | undefined, name: string | null | undefined, parameters: any): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/authorize?";
        if (complete !== undefined)
            url_ += "complete=" + encodeURIComponent("" + complete) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthorizeUsingGET(_response);
        });
    }

    protected processAuthorizeUsingGET(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * authorize
     * @param complete (optional) 
     * @param model (optional) model
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    authorizeUsingHEAD(complete: boolean | null | undefined, model: any | null | undefined, name: string | null | undefined, parameters: any): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/authorize?";
        if (complete !== undefined)
            url_ += "complete=" + encodeURIComponent("" + complete) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthorizeUsingHEAD(_response);
        });
    }

    protected processAuthorizeUsingHEAD(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * authorize
     * @param complete (optional) 
     * @param model (optional) model
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    authorizeUsingPOST(complete: boolean | null | undefined, model: any | null | undefined, name: string | null | undefined, parameters: any): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/authorize?";
        if (complete !== undefined)
            url_ += "complete=" + encodeURIComponent("" + complete) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthorizeUsingPOST(_response);
        });
    }

    protected processAuthorizeUsingPOST(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * authorize
     * @param complete (optional) 
     * @param model (optional) model
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    authorizeUsingPUT(complete: boolean | null | undefined, model: any | null | undefined, name: string | null | undefined, parameters: any): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/authorize?";
        if (complete !== undefined)
            url_ += "complete=" + encodeURIComponent("" + complete) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthorizeUsingPUT(_response);
        });
    }

    protected processAuthorizeUsingPUT(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * authorize
     * @param complete (optional) 
     * @param model (optional) model
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    authorizeUsingDELETE(complete: boolean | null | undefined, model: any | null | undefined, name: string | null | undefined, parameters: any): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/authorize?";
        if (complete !== undefined)
            url_ += "complete=" + encodeURIComponent("" + complete) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthorizeUsingDELETE(_response);
        });
    }

    protected processAuthorizeUsingDELETE(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * authorize
     * @param complete (optional) 
     * @param model (optional) model
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    authorizeUsingOPTIONS(complete: boolean | null | undefined, model: any | null | undefined, name: string | null | undefined, parameters: any): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/authorize?";
        if (complete !== undefined)
            url_ += "complete=" + encodeURIComponent("" + complete) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthorizeUsingOPTIONS(_response);
        });
    }

    protected processAuthorizeUsingOPTIONS(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * authorize
     * @param complete (optional) 
     * @param model (optional) model
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    authorizeUsingPATCH(complete: boolean | null | undefined, model: any | null | undefined, name: string | null | undefined, parameters: any): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/authorize?";
        if (complete !== undefined)
            url_ += "complete=" + encodeURIComponent("" + complete) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthorizeUsingPATCH(_response);
        });
    }

    protected processAuthorizeUsingPATCH(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * login
     * @param auth_code (optional) 
     * @param authorization_code (optional) 
     * @param code (optional) 
     * @param oauth_token (optional) 
     * @param oauth_verifier (optional) 
     * @param source source
     * @param state (optional) 
     * @return OK
     */
    loginUsingGET(auth_code: string | null | undefined, authorization_code: string | null | undefined, code: string | null | undefined, oauth_token: string | null | undefined, oauth_verifier: string | null | undefined, source: string, state: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/callback/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (auth_code !== undefined)
            url_ += "auth_code=" + encodeURIComponent("" + auth_code) + "&"; 
        if (authorization_code !== undefined)
            url_ += "authorization_code=" + encodeURIComponent("" + authorization_code) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (oauth_token !== undefined)
            url_ += "oauth_token=" + encodeURIComponent("" + oauth_token) + "&"; 
        if (oauth_verifier !== undefined)
            url_ += "oauth_verifier=" + encodeURIComponent("" + oauth_verifier) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginUsingGET(_response);
        });
    }

    protected processLoginUsingGET(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * login
     * @param auth_code (optional) 
     * @param authorization_code (optional) 
     * @param code (optional) 
     * @param oauth_token (optional) 
     * @param oauth_verifier (optional) 
     * @param source source
     * @param state (optional) 
     * @return OK
     */
    loginUsingHEAD(auth_code: string | null | undefined, authorization_code: string | null | undefined, code: string | null | undefined, oauth_token: string | null | undefined, oauth_verifier: string | null | undefined, source: string, state: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/callback/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (auth_code !== undefined)
            url_ += "auth_code=" + encodeURIComponent("" + auth_code) + "&"; 
        if (authorization_code !== undefined)
            url_ += "authorization_code=" + encodeURIComponent("" + authorization_code) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (oauth_token !== undefined)
            url_ += "oauth_token=" + encodeURIComponent("" + oauth_token) + "&"; 
        if (oauth_verifier !== undefined)
            url_ += "oauth_verifier=" + encodeURIComponent("" + oauth_verifier) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginUsingHEAD(_response);
        });
    }

    protected processLoginUsingHEAD(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * login
     * @param auth_code (optional) 
     * @param authorization_code (optional) 
     * @param code (optional) 
     * @param oauth_token (optional) 
     * @param oauth_verifier (optional) 
     * @param source source
     * @param state (optional) 
     * @return OK
     */
    loginUsingPOST(auth_code: string | null | undefined, authorization_code: string | null | undefined, code: string | null | undefined, oauth_token: string | null | undefined, oauth_verifier: string | null | undefined, source: string, state: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/callback/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (auth_code !== undefined)
            url_ += "auth_code=" + encodeURIComponent("" + auth_code) + "&"; 
        if (authorization_code !== undefined)
            url_ += "authorization_code=" + encodeURIComponent("" + authorization_code) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (oauth_token !== undefined)
            url_ += "oauth_token=" + encodeURIComponent("" + oauth_token) + "&"; 
        if (oauth_verifier !== undefined)
            url_ += "oauth_verifier=" + encodeURIComponent("" + oauth_verifier) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginUsingPOST(_response);
        });
    }

    protected processLoginUsingPOST(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * login
     * @param auth_code (optional) 
     * @param authorization_code (optional) 
     * @param code (optional) 
     * @param oauth_token (optional) 
     * @param oauth_verifier (optional) 
     * @param source source
     * @param state (optional) 
     * @return OK
     */
    loginUsingPUT(auth_code: string | null | undefined, authorization_code: string | null | undefined, code: string | null | undefined, oauth_token: string | null | undefined, oauth_verifier: string | null | undefined, source: string, state: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/callback/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (auth_code !== undefined)
            url_ += "auth_code=" + encodeURIComponent("" + auth_code) + "&"; 
        if (authorization_code !== undefined)
            url_ += "authorization_code=" + encodeURIComponent("" + authorization_code) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (oauth_token !== undefined)
            url_ += "oauth_token=" + encodeURIComponent("" + oauth_token) + "&"; 
        if (oauth_verifier !== undefined)
            url_ += "oauth_verifier=" + encodeURIComponent("" + oauth_verifier) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginUsingPUT(_response);
        });
    }

    protected processLoginUsingPUT(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * login
     * @param auth_code (optional) 
     * @param authorization_code (optional) 
     * @param code (optional) 
     * @param oauth_token (optional) 
     * @param oauth_verifier (optional) 
     * @param source source
     * @param state (optional) 
     * @return OK
     */
    loginUsingDELETE(auth_code: string | null | undefined, authorization_code: string | null | undefined, code: string | null | undefined, oauth_token: string | null | undefined, oauth_verifier: string | null | undefined, source: string, state: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/callback/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (auth_code !== undefined)
            url_ += "auth_code=" + encodeURIComponent("" + auth_code) + "&"; 
        if (authorization_code !== undefined)
            url_ += "authorization_code=" + encodeURIComponent("" + authorization_code) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (oauth_token !== undefined)
            url_ += "oauth_token=" + encodeURIComponent("" + oauth_token) + "&"; 
        if (oauth_verifier !== undefined)
            url_ += "oauth_verifier=" + encodeURIComponent("" + oauth_verifier) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginUsingDELETE(_response);
        });
    }

    protected processLoginUsingDELETE(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * login
     * @param auth_code (optional) 
     * @param authorization_code (optional) 
     * @param code (optional) 
     * @param oauth_token (optional) 
     * @param oauth_verifier (optional) 
     * @param source source
     * @param state (optional) 
     * @return OK
     */
    loginUsingOPTIONS(auth_code: string | null | undefined, authorization_code: string | null | undefined, code: string | null | undefined, oauth_token: string | null | undefined, oauth_verifier: string | null | undefined, source: string, state: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/callback/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (auth_code !== undefined)
            url_ += "auth_code=" + encodeURIComponent("" + auth_code) + "&"; 
        if (authorization_code !== undefined)
            url_ += "authorization_code=" + encodeURIComponent("" + authorization_code) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (oauth_token !== undefined)
            url_ += "oauth_token=" + encodeURIComponent("" + oauth_token) + "&"; 
        if (oauth_verifier !== undefined)
            url_ += "oauth_verifier=" + encodeURIComponent("" + oauth_verifier) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginUsingOPTIONS(_response);
        });
    }

    protected processLoginUsingOPTIONS(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * login
     * @param auth_code (optional) 
     * @param authorization_code (optional) 
     * @param code (optional) 
     * @param oauth_token (optional) 
     * @param oauth_verifier (optional) 
     * @param source source
     * @param state (optional) 
     * @return OK
     */
    loginUsingPATCH(auth_code: string | null | undefined, authorization_code: string | null | undefined, code: string | null | undefined, oauth_token: string | null | undefined, oauth_verifier: string | null | undefined, source: string, state: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/callback/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (auth_code !== undefined)
            url_ += "auth_code=" + encodeURIComponent("" + auth_code) + "&"; 
        if (authorization_code !== undefined)
            url_ += "authorization_code=" + encodeURIComponent("" + authorization_code) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (oauth_token !== undefined)
            url_ += "oauth_token=" + encodeURIComponent("" + oauth_token) + "&"; 
        if (oauth_verifier !== undefined)
            url_ += "oauth_verifier=" + encodeURIComponent("" + oauth_verifier) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginUsingPATCH(_response);
        });
    }

    protected processLoginUsingPATCH(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * captcha
     * @return OK
     */
    captchaUsingGET(): Promise<{ [key: string] : any; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCaptchaUsingGET(_response);
        });
    }

    protected processCaptchaUsingGET(response: AxiosResponse): Promise<{ [key: string] : any; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : any; }>(<any>null);
    }

    /**
     * checkToken
     * @param token token
     * @return OK
     */
    checkTokenUsingGET(token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/check_token?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckTokenUsingGET(_response);
        });
    }

    protected processCheckTokenUsingGET(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * checkToken
     * @param token token
     * @return OK
     */
    checkTokenUsingHEAD(token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/check_token?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckTokenUsingHEAD(_response);
        });
    }

    protected processCheckTokenUsingHEAD(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * checkToken
     * @param token token
     * @return OK
     */
    checkTokenUsingPOST(token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/check_token?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckTokenUsingPOST(_response);
        });
    }

    protected processCheckTokenUsingPOST(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * checkToken
     * @param token token
     * @return OK
     */
    checkTokenUsingPUT(token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/check_token?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckTokenUsingPUT(_response);
        });
    }

    protected processCheckTokenUsingPUT(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * checkToken
     * @param token token
     * @return OK
     */
    checkTokenUsingDELETE(token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/check_token?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckTokenUsingDELETE(_response);
        });
    }

    protected processCheckTokenUsingDELETE(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * checkToken
     * @param token token
     * @return OK
     */
    checkTokenUsingOPTIONS(token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/check_token?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckTokenUsingOPTIONS(_response);
        });
    }

    protected processCheckTokenUsingOPTIONS(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * checkToken
     * @param token token
     * @return OK
     */
    checkTokenUsingPATCH(token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/check_token?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCheckTokenUsingPATCH(_response);
        });
    }

    protected processCheckTokenUsingPATCH(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * clearCache
     * @return OK
     */
    clearCacheUsingGET(): Promise<{ [key: string] : any; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/clear-cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClearCacheUsingGET(_response);
        });
    }

    protected processClearCacheUsingGET(response: AxiosResponse): Promise<{ [key: string] : any; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : any; }>(<any>null);
    }

    /**
     * getAccessConfirmation
     * @param model (optional) model
     * @return OK
     */
    getAccessConfirmationUsingGET(model: any | null | undefined): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/confirm_access?";
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessConfirmationUsingGET(_response);
        });
    }

    protected processGetAccessConfirmationUsingGET(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * getAccessConfirmation
     * @param model (optional) model
     * @return OK
     */
    getAccessConfirmationUsingHEAD(model: any | null | undefined): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/confirm_access?";
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessConfirmationUsingHEAD(_response);
        });
    }

    protected processGetAccessConfirmationUsingHEAD(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * getAccessConfirmation
     * @param model (optional) model
     * @return OK
     */
    getAccessConfirmationUsingPOST(model: any | null | undefined): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/confirm_access?";
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessConfirmationUsingPOST(_response);
        });
    }

    protected processGetAccessConfirmationUsingPOST(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * getAccessConfirmation
     * @param model (optional) model
     * @return OK
     */
    getAccessConfirmationUsingPUT(model: any | null | undefined): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/confirm_access?";
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessConfirmationUsingPUT(_response);
        });
    }

    protected processGetAccessConfirmationUsingPUT(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * getAccessConfirmation
     * @param model (optional) model
     * @return OK
     */
    getAccessConfirmationUsingDELETE(model: any | null | undefined): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/confirm_access?";
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessConfirmationUsingDELETE(_response);
        });
    }

    protected processGetAccessConfirmationUsingDELETE(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * getAccessConfirmation
     * @param model (optional) model
     * @return OK
     */
    getAccessConfirmationUsingOPTIONS(model: any | null | undefined): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/confirm_access?";
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessConfirmationUsingOPTIONS(_response);
        });
    }

    protected processGetAccessConfirmationUsingOPTIONS(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * getAccessConfirmation
     * @param model (optional) model
     * @return OK
     */
    getAccessConfirmationUsingPATCH(model: any | null | undefined): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/confirm_access?";
        if (model !== undefined)
            url_ += "model=" + encodeURIComponent("" + model) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessConfirmationUsingPATCH(_response);
        });
    }

    protected processGetAccessConfirmationUsingPATCH(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * handleError
     * @return OK
     */
    handleErrorUsingGET(): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHandleErrorUsingGET(_response);
        });
    }

    protected processHandleErrorUsingGET(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * handleError
     * @return OK
     */
    handleErrorUsingHEAD(): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHandleErrorUsingHEAD(_response);
        });
    }

    protected processHandleErrorUsingHEAD(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * handleError
     * @return OK
     */
    handleErrorUsingPOST(): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHandleErrorUsingPOST(_response);
        });
    }

    protected processHandleErrorUsingPOST(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * handleError
     * @return OK
     */
    handleErrorUsingPUT(): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHandleErrorUsingPUT(_response);
        });
    }

    protected processHandleErrorUsingPUT(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * handleError
     * @return OK
     */
    handleErrorUsingDELETE(): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHandleErrorUsingDELETE(_response);
        });
    }

    protected processHandleErrorUsingDELETE(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * handleError
     * @return OK
     */
    handleErrorUsingOPTIONS(): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHandleErrorUsingOPTIONS(_response);
        });
    }

    protected processHandleErrorUsingOPTIONS(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * handleError
     * @return OK
     */
    handleErrorUsingPATCH(): Promise<ModelAndView> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processHandleErrorUsingPATCH(_response);
        });
    }

    protected processHandleErrorUsingPATCH(response: AxiosResponse): Promise<ModelAndView> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelAndView.fromJS(resultData200) : new ModelAndView();
            return result200;
        }
        return Promise.resolve<ModelAndView>(<any>null);
    }

    /**
     * logout
     * @return OK
     */
    logoutUsingGET(): Promise<{ [key: string] : any; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogoutUsingGET(_response);
        });
    }

    protected processLogoutUsingGET(response: AxiosResponse): Promise<{ [key: string] : any; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : any; }>(<any>null);
    }

    /**
     * refreshAuth
     * @param source source
     * @param token (optional) token
     * @return OK
     */
    refreshAuthUsingGET(source: string, token: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/refresh/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshAuthUsingGET(_response);
        });
    }

    protected processRefreshAuthUsingGET(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * refreshAuth
     * @param source source
     * @param token (optional) token
     * @return OK
     */
    refreshAuthUsingHEAD(source: string, token: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/refresh/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshAuthUsingHEAD(_response);
        });
    }

    protected processRefreshAuthUsingHEAD(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * refreshAuth
     * @param source source
     * @param token (optional) token
     * @return OK
     */
    refreshAuthUsingPOST(source: string, token: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/refresh/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshAuthUsingPOST(_response);
        });
    }

    protected processRefreshAuthUsingPOST(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * refreshAuth
     * @param source source
     * @param token (optional) token
     * @return OK
     */
    refreshAuthUsingPUT(source: string, token: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/refresh/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshAuthUsingPUT(_response);
        });
    }

    protected processRefreshAuthUsingPUT(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * refreshAuth
     * @param source source
     * @param token (optional) token
     * @return OK
     */
    refreshAuthUsingDELETE(source: string, token: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/refresh/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshAuthUsingDELETE(_response);
        });
    }

    protected processRefreshAuthUsingDELETE(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * refreshAuth
     * @param source source
     * @param token (optional) token
     * @return OK
     */
    refreshAuthUsingOPTIONS(source: string, token: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/refresh/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshAuthUsingOPTIONS(_response);
        });
    }

    protected processRefreshAuthUsingOPTIONS(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * refreshAuth
     * @param source source
     * @param token (optional) token
     * @return OK
     */
    refreshAuthUsingPATCH(source: string, token: string | null | undefined): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/refresh/{source}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRefreshAuthUsingPATCH(_response);
        });
    }

    protected processRefreshAuthUsingPATCH(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * renderAuth
     * @param source source
     * @return OK
     */
    renderAuthUsingGET(source: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/render/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderAuthUsingGET(_response);
        });
    }

    protected processRenderAuthUsingGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * renderAuth
     * @param source source
     * @return OK
     */
    renderAuthUsingHEAD(source: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/render/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderAuthUsingHEAD(_response);
        });
    }

    protected processRenderAuthUsingHEAD(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * renderAuth
     * @param source source
     * @return OK
     */
    renderAuthUsingPOST(source: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/render/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderAuthUsingPOST(_response);
        });
    }

    protected processRenderAuthUsingPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * renderAuth
     * @param source source
     * @return OK
     */
    renderAuthUsingPUT(source: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/render/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderAuthUsingPUT(_response);
        });
    }

    protected processRenderAuthUsingPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * renderAuth
     * @param source source
     * @return OK
     */
    renderAuthUsingDELETE(source: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/render/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderAuthUsingDELETE(_response);
        });
    }

    protected processRenderAuthUsingDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * renderAuth
     * @param source source
     * @return OK
     */
    renderAuthUsingOPTIONS(source: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/render/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderAuthUsingOPTIONS(_response);
        });
    }

    protected processRenderAuthUsingOPTIONS(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * renderAuth
     * @param source source
     * @return OK
     */
    renderAuthUsingPATCH(source: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/render/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderAuthUsingPATCH(_response);
        });
    }

    protected processRenderAuthUsingPATCH(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * revokeAuth
     * @param source source
     * @param token token
     * @return OK
     */
    revokeAuthUsingGET(source: string, token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/revoke/{source}/{token}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRevokeAuthUsingGET(_response);
        });
    }

    protected processRevokeAuthUsingGET(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * revokeAuth
     * @param source source
     * @param token token
     * @return OK
     */
    revokeAuthUsingHEAD(source: string, token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/revoke/{source}/{token}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRevokeAuthUsingHEAD(_response);
        });
    }

    protected processRevokeAuthUsingHEAD(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * revokeAuth
     * @param source source
     * @param token token
     * @return OK
     */
    revokeAuthUsingPOST(source: string, token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/revoke/{source}/{token}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRevokeAuthUsingPOST(_response);
        });
    }

    protected processRevokeAuthUsingPOST(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * revokeAuth
     * @param source source
     * @param token token
     * @return OK
     */
    revokeAuthUsingPUT(source: string, token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/revoke/{source}/{token}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRevokeAuthUsingPUT(_response);
        });
    }

    protected processRevokeAuthUsingPUT(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * revokeAuth
     * @param source source
     * @param token token
     * @return OK
     */
    revokeAuthUsingDELETE(source: string, token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/revoke/{source}/{token}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRevokeAuthUsingDELETE(_response);
        });
    }

    protected processRevokeAuthUsingDELETE(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * revokeAuth
     * @param source source
     * @param token token
     * @return OK
     */
    revokeAuthUsingOPTIONS(source: string, token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/revoke/{source}/{token}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRevokeAuthUsingOPTIONS(_response);
        });
    }

    protected processRevokeAuthUsingOPTIONS(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * revokeAuth
     * @param source source
     * @param token token
     * @return OK
     */
    revokeAuthUsingPATCH(source: string, token: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/revoke/{source}/{token}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source)); 
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRevokeAuthUsingPATCH(_response);
        });
    }

    protected processRevokeAuthUsingPATCH(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * getAccessToken
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    getAccessTokenUsingGET(name: string | null | undefined, parameters: any): Promise<OAuth2AccessToken> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/token?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccessTokenUsingGET(_response);
        });
    }

    protected processGetAccessTokenUsingGET(response: AxiosResponse): Promise<OAuth2AccessToken> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OAuth2AccessToken.fromJS(resultData200) : new OAuth2AccessToken();
            return result200;
        }
        return Promise.resolve<OAuth2AccessToken>(<any>null);
    }

    /**
     * postAccessToken
     * @param name (optional) 
     * @param parameters parameters
     * @return OK
     */
    postAccessTokenUsingPOST(name: string | null | undefined, parameters: any): Promise<OAuth2AccessToken> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/token?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (parameters === undefined || parameters === null)
            throw new Error("The parameter 'parameters' must be defined and cannot be null.");
        else
            url_ += "parameters=" + encodeURIComponent("" + parameters) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPostAccessTokenUsingPOST(_response);
        });
    }

    protected processPostAccessTokenUsingPOST(response: AxiosResponse): Promise<OAuth2AccessToken> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? OAuth2AccessToken.fromJS(resultData200) : new OAuth2AccessToken();
            return result200;
        }
        return Promise.resolve<OAuth2AccessToken>(<any>null);
    }

    /**
     * getKey
     * @param name (optional) 
     * @return OK
     */
    getKeyUsingGET(name: string | null | undefined): Promise<{ [key: string] : string; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/token_key?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetKeyUsingGET(_response);
        });
    }

    protected processGetKeyUsingGET(response: AxiosResponse): Promise<{ [key: string] : string; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : string; }>(<any>null);
    }

    /**
     * currentUser
     * @param authenticated (optional) 
     * @param authorities0_authority (optional) 
     * @param credentials (optional) 
     * @param details (optional) 
     * @param principal (optional) 
     * @return OK
     */
    currentUserUsingGET(authenticated: boolean | null | undefined, authorities0_authority: string | null | undefined, credentials: any | null | undefined, details: any | null | undefined, principal: any | null | undefined): Promise<ROfAuthentication> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/user-info?";
        if (authenticated !== undefined)
            url_ += "authenticated=" + encodeURIComponent("" + authenticated) + "&"; 
        if (authorities0_authority !== undefined)
            url_ += "authorities[0].authority=" + encodeURIComponent("" + authorities0_authority) + "&"; 
        if (credentials !== undefined)
            url_ += "credentials=" + encodeURIComponent("" + credentials) + "&"; 
        if (details !== undefined)
            url_ += "details=" + encodeURIComponent("" + details) + "&"; 
        if (principal !== undefined)
            url_ += "principal=" + encodeURIComponent("" + principal) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCurrentUserUsingGET(_response);
        });
    }

    protected processCurrentUserUsingGET(response: AxiosResponse): Promise<ROfAuthentication> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfAuthentication.fromJS(resultData200) : new ROfAuthentication();
            return result200;
        }
        return Promise.resolve<ROfAuthentication>(<any>null);
    }

    /**
     * smsValidateCode
     * @param mobile (optional) mobile
     * @param tenantId (optional) tenantId
     * @return OK
     */
    smsValidateCodeUsingGET(mobile: string | null | undefined, tenantId: string | null | undefined): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/oauth/validate-code?";
        if (mobile !== undefined)
            url_ += "mobile=" + encodeURIComponent("" + mobile) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSmsValidateCodeUsingGET(_response);
        });
    }

    protected processSmsValidateCodeUsingGET(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * webDavAuthenticate
     * @param webDavLogin webDavLogin
     * @return OK
     */
    webDavAuthenticateUsingPOST(webDavLogin: WebDavLogin): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.1.20:31080/blade-auth')+ "/web-dav/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webDavLogin);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processWebDavAuthenticateUsingPOST(_response);
        });
    }

    protected processWebDavAuthenticateUsingPOST(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }
}

export class ApiAuthenticateDto implements IApiAuthenticateDto {
    account!: string | undefined;
    mode!: number | undefined;
    passportKey!: PassportKeyDto | undefined;
    tenant!: string | undefined;

    constructor(data?: IApiAuthenticateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"];
            this.mode = data["mode"];
            this.passportKey = data["passportKey"] ? PassportKeyDto.fromJS(data["passportKey"]) : <any>undefined;
            this.tenant = data["tenant"];
        }
    }

    static fromJS(data: any): ApiAuthenticateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthenticateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["mode"] = this.mode;
        data["passportKey"] = this.passportKey ? this.passportKey.toJSON() : <any>undefined;
        data["tenant"] = this.tenant;
        return data; 
    }
}

export interface IApiAuthenticateDto {
    account: string | undefined;
    mode: number | undefined;
    passportKey: PassportKeyDto | undefined;
    tenant: string | undefined;
}

export class AuthenticateVO implements IAuthenticateVO {
    rootPath!: string | undefined;
    token!: string | undefined;

    constructor(data?: IAuthenticateVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rootPath = data["rootPath"];
            this.token = data["token"];
        }
    }

    static fromJS(data: any): AuthenticateVO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rootPath"] = this.rootPath;
        data["token"] = this.token;
        return data; 
    }
}

export interface IAuthenticateVO {
    rootPath: string | undefined;
    token: string | undefined;
}

export class Authentication implements IAuthentication {
    authenticated!: boolean | undefined;
    authorities!: GrantedAuthority[] | undefined;
    credentials!: any | undefined;
    details!: any | undefined;
    name!: string | undefined;
    principal!: any | undefined;

    constructor(data?: IAuthentication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authenticated = data["authenticated"];
            if (data["authorities"] && data["authorities"].constructor === Array) {
                this.authorities = [] as any;
                for (let item of data["authorities"])
                    this.authorities!.push(GrantedAuthority.fromJS(item));
            }
            this.credentials = data["credentials"];
            this.details = data["details"];
            this.name = data["name"];
            this.principal = data["principal"];
        }
    }

    static fromJS(data: any): Authentication {
        data = typeof data === 'object' ? data : {};
        let result = new Authentication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticated"] = this.authenticated;
        if (this.authorities && this.authorities.constructor === Array) {
            data["authorities"] = [];
            for (let item of this.authorities)
                data["authorities"].push(item.toJSON());
        }
        data["credentials"] = this.credentials;
        data["details"] = this.details;
        data["name"] = this.name;
        data["principal"] = this.principal;
        return data; 
    }
}

export interface IAuthentication {
    authenticated: boolean | undefined;
    authorities: GrantedAuthority[] | undefined;
    credentials: any | undefined;
    details: any | undefined;
    name: string | undefined;
    principal: any | undefined;
}

export class GrantedAuthority implements IGrantedAuthority {
    authority!: string | undefined;

    constructor(data?: IGrantedAuthority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authority = data["authority"];
        }
    }

    static fromJS(data: any): GrantedAuthority {
        data = typeof data === 'object' ? data : {};
        let result = new GrantedAuthority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        return data; 
    }
}

export interface IGrantedAuthority {
    authority: string | undefined;
}

export class Locale implements ILocale {
    country!: string | undefined;
    displayCountry!: string | undefined;
    displayLanguage!: string | undefined;
    displayName!: string | undefined;
    displayScript!: string | undefined;
    displayVariant!: string | undefined;
    extensionKeys!: any[] | undefined;
    iso3Country!: string | undefined;
    iso3Language!: string | undefined;
    language!: string | undefined;
    script!: string | undefined;
    unicodeLocaleAttributes!: string[] | undefined;
    unicodeLocaleKeys!: string[] | undefined;
    variant!: string | undefined;

    constructor(data?: ILocale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.displayCountry = data["displayCountry"];
            this.displayLanguage = data["displayLanguage"];
            this.displayName = data["displayName"];
            this.displayScript = data["displayScript"];
            this.displayVariant = data["displayVariant"];
            if (data["extensionKeys"] && data["extensionKeys"].constructor === Array) {
                this.extensionKeys = [] as any;
                for (let item of data["extensionKeys"])
                    this.extensionKeys!.push(item);
            }
            this.iso3Country = data["iso3Country"];
            this.iso3Language = data["iso3Language"];
            this.language = data["language"];
            this.script = data["script"];
            if (data["unicodeLocaleAttributes"] && data["unicodeLocaleAttributes"].constructor === Array) {
                this.unicodeLocaleAttributes = [] as any;
                for (let item of data["unicodeLocaleAttributes"])
                    this.unicodeLocaleAttributes!.push(item);
            }
            if (data["unicodeLocaleKeys"] && data["unicodeLocaleKeys"].constructor === Array) {
                this.unicodeLocaleKeys = [] as any;
                for (let item of data["unicodeLocaleKeys"])
                    this.unicodeLocaleKeys!.push(item);
            }
            this.variant = data["variant"];
        }
    }

    static fromJS(data: any): Locale {
        data = typeof data === 'object' ? data : {};
        let result = new Locale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["displayCountry"] = this.displayCountry;
        data["displayLanguage"] = this.displayLanguage;
        data["displayName"] = this.displayName;
        data["displayScript"] = this.displayScript;
        data["displayVariant"] = this.displayVariant;
        if (this.extensionKeys && this.extensionKeys.constructor === Array) {
            data["extensionKeys"] = [];
            for (let item of this.extensionKeys)
                data["extensionKeys"].push(item);
        }
        data["iso3Country"] = this.iso3Country;
        data["iso3Language"] = this.iso3Language;
        data["language"] = this.language;
        data["script"] = this.script;
        if (this.unicodeLocaleAttributes && this.unicodeLocaleAttributes.constructor === Array) {
            data["unicodeLocaleAttributes"] = [];
            for (let item of this.unicodeLocaleAttributes)
                data["unicodeLocaleAttributes"].push(item);
        }
        if (this.unicodeLocaleKeys && this.unicodeLocaleKeys.constructor === Array) {
            data["unicodeLocaleKeys"] = [];
            for (let item of this.unicodeLocaleKeys)
                data["unicodeLocaleKeys"].push(item);
        }
        data["variant"] = this.variant;
        return data; 
    }
}

export interface ILocale {
    country: string | undefined;
    displayCountry: string | undefined;
    displayLanguage: string | undefined;
    displayName: string | undefined;
    displayScript: string | undefined;
    displayVariant: string | undefined;
    extensionKeys: any[] | undefined;
    iso3Country: string | undefined;
    iso3Language: string | undefined;
    language: string | undefined;
    script: string | undefined;
    unicodeLocaleAttributes: string[] | undefined;
    unicodeLocaleKeys: string[] | undefined;
    variant: string | undefined;
}

export class Locale_1 implements ILocale_1 {
    country!: string | undefined;
    displayCountry!: string | undefined;
    displayLanguage!: string | undefined;
    displayName!: string | undefined;
    displayScript!: string | undefined;
    displayVariant!: string | undefined;
    extensionKeys!: any[] | undefined;
    iso3Country!: string | undefined;
    iso3Language!: string | undefined;
    language!: string | undefined;
    script!: string | undefined;
    unicodeLocaleAttributes!: string[] | undefined;
    unicodeLocaleKeys!: string[] | undefined;
    variant!: string | undefined;

    constructor(data?: ILocale_1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.displayCountry = data["displayCountry"];
            this.displayLanguage = data["displayLanguage"];
            this.displayName = data["displayName"];
            this.displayScript = data["displayScript"];
            this.displayVariant = data["displayVariant"];
            if (data["extensionKeys"] && data["extensionKeys"].constructor === Array) {
                this.extensionKeys = [] as any;
                for (let item of data["extensionKeys"])
                    this.extensionKeys!.push(item);
            }
            this.iso3Country = data["iso3Country"];
            this.iso3Language = data["iso3Language"];
            this.language = data["language"];
            this.script = data["script"];
            if (data["unicodeLocaleAttributes"] && data["unicodeLocaleAttributes"].constructor === Array) {
                this.unicodeLocaleAttributes = [] as any;
                for (let item of data["unicodeLocaleAttributes"])
                    this.unicodeLocaleAttributes!.push(item);
            }
            if (data["unicodeLocaleKeys"] && data["unicodeLocaleKeys"].constructor === Array) {
                this.unicodeLocaleKeys = [] as any;
                for (let item of data["unicodeLocaleKeys"])
                    this.unicodeLocaleKeys!.push(item);
            }
            this.variant = data["variant"];
        }
    }

    static fromJS(data: any): Locale_1 {
        data = typeof data === 'object' ? data : {};
        let result = new Locale_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["displayCountry"] = this.displayCountry;
        data["displayLanguage"] = this.displayLanguage;
        data["displayName"] = this.displayName;
        data["displayScript"] = this.displayScript;
        data["displayVariant"] = this.displayVariant;
        if (this.extensionKeys && this.extensionKeys.constructor === Array) {
            data["extensionKeys"] = [];
            for (let item of this.extensionKeys)
                data["extensionKeys"].push(item);
        }
        data["iso3Country"] = this.iso3Country;
        data["iso3Language"] = this.iso3Language;
        data["language"] = this.language;
        data["script"] = this.script;
        if (this.unicodeLocaleAttributes && this.unicodeLocaleAttributes.constructor === Array) {
            data["unicodeLocaleAttributes"] = [];
            for (let item of this.unicodeLocaleAttributes)
                data["unicodeLocaleAttributes"].push(item);
        }
        if (this.unicodeLocaleKeys && this.unicodeLocaleKeys.constructor === Array) {
            data["unicodeLocaleKeys"] = [];
            for (let item of this.unicodeLocaleKeys)
                data["unicodeLocaleKeys"].push(item);
        }
        data["variant"] = this.variant;
        return data; 
    }
}

export interface ILocale_1 {
    country: string | undefined;
    displayCountry: string | undefined;
    displayLanguage: string | undefined;
    displayName: string | undefined;
    displayScript: string | undefined;
    displayVariant: string | undefined;
    extensionKeys: any[] | undefined;
    iso3Country: string | undefined;
    iso3Language: string | undefined;
    language: string | undefined;
    script: string | undefined;
    unicodeLocaleAttributes: string[] | undefined;
    unicodeLocaleKeys: string[] | undefined;
    variant: string | undefined;
}

export class Locale_2 implements ILocale_2 {
    country!: string | undefined;
    displayCountry!: string | undefined;
    displayLanguage!: string | undefined;
    displayName!: string | undefined;
    displayScript!: string | undefined;
    displayVariant!: string | undefined;
    extensionKeys!: any[] | undefined;
    iso3Country!: string | undefined;
    iso3Language!: string | undefined;
    language!: string | undefined;
    script!: string | undefined;
    unicodeLocaleAttributes!: string[] | undefined;
    unicodeLocaleKeys!: string[] | undefined;
    variant!: string | undefined;

    constructor(data?: ILocale_2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.displayCountry = data["displayCountry"];
            this.displayLanguage = data["displayLanguage"];
            this.displayName = data["displayName"];
            this.displayScript = data["displayScript"];
            this.displayVariant = data["displayVariant"];
            if (data["extensionKeys"] && data["extensionKeys"].constructor === Array) {
                this.extensionKeys = [] as any;
                for (let item of data["extensionKeys"])
                    this.extensionKeys!.push(item);
            }
            this.iso3Country = data["iso3Country"];
            this.iso3Language = data["iso3Language"];
            this.language = data["language"];
            this.script = data["script"];
            if (data["unicodeLocaleAttributes"] && data["unicodeLocaleAttributes"].constructor === Array) {
                this.unicodeLocaleAttributes = [] as any;
                for (let item of data["unicodeLocaleAttributes"])
                    this.unicodeLocaleAttributes!.push(item);
            }
            if (data["unicodeLocaleKeys"] && data["unicodeLocaleKeys"].constructor === Array) {
                this.unicodeLocaleKeys = [] as any;
                for (let item of data["unicodeLocaleKeys"])
                    this.unicodeLocaleKeys!.push(item);
            }
            this.variant = data["variant"];
        }
    }

    static fromJS(data: any): Locale_2 {
        data = typeof data === 'object' ? data : {};
        let result = new Locale_2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["displayCountry"] = this.displayCountry;
        data["displayLanguage"] = this.displayLanguage;
        data["displayName"] = this.displayName;
        data["displayScript"] = this.displayScript;
        data["displayVariant"] = this.displayVariant;
        if (this.extensionKeys && this.extensionKeys.constructor === Array) {
            data["extensionKeys"] = [];
            for (let item of this.extensionKeys)
                data["extensionKeys"].push(item);
        }
        data["iso3Country"] = this.iso3Country;
        data["iso3Language"] = this.iso3Language;
        data["language"] = this.language;
        data["script"] = this.script;
        if (this.unicodeLocaleAttributes && this.unicodeLocaleAttributes.constructor === Array) {
            data["unicodeLocaleAttributes"] = [];
            for (let item of this.unicodeLocaleAttributes)
                data["unicodeLocaleAttributes"].push(item);
        }
        if (this.unicodeLocaleKeys && this.unicodeLocaleKeys.constructor === Array) {
            data["unicodeLocaleKeys"] = [];
            for (let item of this.unicodeLocaleKeys)
                data["unicodeLocaleKeys"].push(item);
        }
        data["variant"] = this.variant;
        return data; 
    }
}

export interface ILocale_2 {
    country: string | undefined;
    displayCountry: string | undefined;
    displayLanguage: string | undefined;
    displayName: string | undefined;
    displayScript: string | undefined;
    displayVariant: string | undefined;
    extensionKeys: any[] | undefined;
    iso3Country: string | undefined;
    iso3Language: string | undefined;
    language: string | undefined;
    script: string | undefined;
    unicodeLocaleAttributes: string[] | undefined;
    unicodeLocaleKeys: string[] | undefined;
    variant: string | undefined;
}

export class Locale_3 implements ILocale_3 {
    country!: string | undefined;
    displayCountry!: string | undefined;
    displayLanguage!: string | undefined;
    displayName!: string | undefined;
    displayScript!: string | undefined;
    displayVariant!: string | undefined;
    extensionKeys!: any[] | undefined;
    iso3Country!: string | undefined;
    iso3Language!: string | undefined;
    language!: string | undefined;
    script!: string | undefined;
    unicodeLocaleAttributes!: string[] | undefined;
    unicodeLocaleKeys!: string[] | undefined;
    variant!: string | undefined;

    constructor(data?: ILocale_3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.displayCountry = data["displayCountry"];
            this.displayLanguage = data["displayLanguage"];
            this.displayName = data["displayName"];
            this.displayScript = data["displayScript"];
            this.displayVariant = data["displayVariant"];
            if (data["extensionKeys"] && data["extensionKeys"].constructor === Array) {
                this.extensionKeys = [] as any;
                for (let item of data["extensionKeys"])
                    this.extensionKeys!.push(item);
            }
            this.iso3Country = data["iso3Country"];
            this.iso3Language = data["iso3Language"];
            this.language = data["language"];
            this.script = data["script"];
            if (data["unicodeLocaleAttributes"] && data["unicodeLocaleAttributes"].constructor === Array) {
                this.unicodeLocaleAttributes = [] as any;
                for (let item of data["unicodeLocaleAttributes"])
                    this.unicodeLocaleAttributes!.push(item);
            }
            if (data["unicodeLocaleKeys"] && data["unicodeLocaleKeys"].constructor === Array) {
                this.unicodeLocaleKeys = [] as any;
                for (let item of data["unicodeLocaleKeys"])
                    this.unicodeLocaleKeys!.push(item);
            }
            this.variant = data["variant"];
        }
    }

    static fromJS(data: any): Locale_3 {
        data = typeof data === 'object' ? data : {};
        let result = new Locale_3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["displayCountry"] = this.displayCountry;
        data["displayLanguage"] = this.displayLanguage;
        data["displayName"] = this.displayName;
        data["displayScript"] = this.displayScript;
        data["displayVariant"] = this.displayVariant;
        if (this.extensionKeys && this.extensionKeys.constructor === Array) {
            data["extensionKeys"] = [];
            for (let item of this.extensionKeys)
                data["extensionKeys"].push(item);
        }
        data["iso3Country"] = this.iso3Country;
        data["iso3Language"] = this.iso3Language;
        data["language"] = this.language;
        data["script"] = this.script;
        if (this.unicodeLocaleAttributes && this.unicodeLocaleAttributes.constructor === Array) {
            data["unicodeLocaleAttributes"] = [];
            for (let item of this.unicodeLocaleAttributes)
                data["unicodeLocaleAttributes"].push(item);
        }
        if (this.unicodeLocaleKeys && this.unicodeLocaleKeys.constructor === Array) {
            data["unicodeLocaleKeys"] = [];
            for (let item of this.unicodeLocaleKeys)
                data["unicodeLocaleKeys"].push(item);
        }
        data["variant"] = this.variant;
        return data; 
    }
}

export interface ILocale_3 {
    country: string | undefined;
    displayCountry: string | undefined;
    displayLanguage: string | undefined;
    displayName: string | undefined;
    displayScript: string | undefined;
    displayVariant: string | undefined;
    extensionKeys: any[] | undefined;
    iso3Country: string | undefined;
    iso3Language: string | undefined;
    language: string | undefined;
    script: string | undefined;
    unicodeLocaleAttributes: string[] | undefined;
    unicodeLocaleKeys: string[] | undefined;
    variant: string | undefined;
}

export class ModelAndView implements IModelAndView {
    empty!: boolean | undefined;
    model!: any | undefined;
    modelMap!: { [key: string] : any; } | undefined;
    reference!: boolean | undefined;
    status!: ModelAndViewStatus | undefined;
    view!: View | undefined;
    viewName!: string | undefined;

    constructor(data?: IModelAndView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.empty = data["empty"];
            this.model = data["model"];
            if (data["modelMap"]) {
                this.modelMap = {} as any;
                for (let key in data["modelMap"]) {
                    if (data["modelMap"].hasOwnProperty(key))
                        this.modelMap![key] = data["modelMap"][key];
                }
            }
            this.reference = data["reference"];
            this.status = data["status"];
            this.view = data["view"] ? View.fromJS(data["view"]) : <any>undefined;
            this.viewName = data["viewName"];
        }
    }

    static fromJS(data: any): ModelAndView {
        data = typeof data === 'object' ? data : {};
        let result = new ModelAndView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empty"] = this.empty;
        data["model"] = this.model;
        if (this.modelMap) {
            data["modelMap"] = {};
            for (let key in this.modelMap) {
                if (this.modelMap.hasOwnProperty(key))
                    data["modelMap"][key] = this.modelMap[key];
            }
        }
        data["reference"] = this.reference;
        data["status"] = this.status;
        data["view"] = this.view ? this.view.toJSON() : <any>undefined;
        data["viewName"] = this.viewName;
        return data; 
    }
}

export interface IModelAndView {
    empty: boolean | undefined;
    model: any | undefined;
    modelMap: { [key: string] : any; } | undefined;
    reference: boolean | undefined;
    status: ModelAndViewStatus | undefined;
    view: View | undefined;
    viewName: string | undefined;
}

export class OAuth2AccessToken implements IOAuth2AccessToken {
    additionalInformation!: any | undefined;
    expiration!: Date | undefined;
    expired!: boolean | undefined;
    expiresIn!: number | undefined;
    refreshToken!: OAuth2RefreshToken | undefined;
    scope!: string[] | undefined;
    tokenType!: string | undefined;
    value!: string | undefined;

    constructor(data?: IOAuth2AccessToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.additionalInformation = data["additionalInformation"];
            this.expiration = data["expiration"] ? new Date(data["expiration"].toString()) : <any>undefined;
            this.expired = data["expired"];
            this.expiresIn = data["expiresIn"];
            this.refreshToken = data["refreshToken"] ? OAuth2RefreshToken.fromJS(data["refreshToken"]) : <any>undefined;
            if (data["scope"] && data["scope"].constructor === Array) {
                this.scope = [] as any;
                for (let item of data["scope"])
                    this.scope!.push(item);
            }
            this.tokenType = data["tokenType"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): OAuth2AccessToken {
        data = typeof data === 'object' ? data : {};
        let result = new OAuth2AccessToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalInformation"] = this.additionalInformation;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["expired"] = this.expired;
        data["expiresIn"] = this.expiresIn;
        data["refreshToken"] = this.refreshToken ? this.refreshToken.toJSON() : <any>undefined;
        if (this.scope && this.scope.constructor === Array) {
            data["scope"] = [];
            for (let item of this.scope)
                data["scope"].push(item);
        }
        data["tokenType"] = this.tokenType;
        data["value"] = this.value;
        return data; 
    }
}

export interface IOAuth2AccessToken {
    additionalInformation: any | undefined;
    expiration: Date | undefined;
    expired: boolean | undefined;
    expiresIn: number | undefined;
    refreshToken: OAuth2RefreshToken | undefined;
    scope: string[] | undefined;
    tokenType: string | undefined;
    value: string | undefined;
}

export class OAuth2RefreshToken implements IOAuth2RefreshToken {
    value!: string | undefined;

    constructor(data?: IOAuth2RefreshToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
        }
    }

    static fromJS(data: any): OAuth2RefreshToken {
        data = typeof data === 'object' ? data : {};
        let result = new OAuth2RefreshToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }
}

export interface IOAuth2RefreshToken {
    value: string | undefined;
}

export class PassportKeyDto implements IPassportKeyDto {
    cnonce!: string | undefined;
    method!: string | undefined;
    nc!: string | undefined;
    nonce!: string | undefined;
    password!: string | undefined;
    qop!: string | undefined;
    realm!: string | undefined;
    response!: string | undefined;
    uri!: string | undefined;

    constructor(data?: IPassportKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cnonce = data["cnonce"];
            this.method = data["method"];
            this.nc = data["nc"];
            this.nonce = data["nonce"];
            this.password = data["password"];
            this.qop = data["qop"];
            this.realm = data["realm"];
            this.response = data["response"];
            this.uri = data["uri"];
        }
    }

    static fromJS(data: any): PassportKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassportKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnonce"] = this.cnonce;
        data["method"] = this.method;
        data["nc"] = this.nc;
        data["nonce"] = this.nonce;
        data["password"] = this.password;
        data["qop"] = this.qop;
        data["realm"] = this.realm;
        data["response"] = this.response;
        data["uri"] = this.uri;
        return data; 
    }
}

export interface IPassportKeyDto {
    cnonce: string | undefined;
    method: string | undefined;
    nc: string | undefined;
    nonce: string | undefined;
    password: string | undefined;
    qop: string | undefined;
    realm: string | undefined;
    response: string | undefined;
    uri: string | undefined;
}

/** 返回信息 */
export class R implements IR {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): R {
        data = typeof data === 'object' ? data : {};
        let result = new R();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IR {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfAuthenticateVO implements IROfAuthenticateVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: AuthenticateVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfAuthenticateVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? AuthenticateVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfAuthenticateVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfAuthenticateVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfAuthenticateVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: AuthenticateVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfAuthentication implements IROfAuthentication {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: Authentication | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfAuthentication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? Authentication.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfAuthentication {
        data = typeof data === 'object' ? data : {};
        let result = new ROfAuthentication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfAuthentication {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: Authentication | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class View implements IView {
    contentType!: string | undefined;

    constructor(data?: IView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
        }
    }

    static fromJS(data: any): View {
        data = typeof data === 'object' ? data : {};
        let result = new View();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        return data; 
    }
}

export interface IView {
    contentType: string | undefined;
}

export class WebDavLogin implements IWebDavLogin {
    cnonce!: string | undefined;
    ip!: string | undefined;
    method!: string | undefined;
    nc!: string | undefined;
    nonce!: string | undefined;
    qop!: string | undefined;
    realm!: string | undefined;
    response!: string | undefined;
    uri!: string | undefined;
    username!: string | undefined;

    constructor(data?: IWebDavLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cnonce = data["cnonce"];
            this.ip = data["ip"];
            this.method = data["method"];
            this.nc = data["nc"];
            this.nonce = data["nonce"];
            this.qop = data["qop"];
            this.realm = data["realm"];
            this.response = data["response"];
            this.uri = data["uri"];
            this.username = data["username"];
        }
    }

    static fromJS(data: any): WebDavLogin {
        data = typeof data === 'object' ? data : {};
        let result = new WebDavLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnonce"] = this.cnonce;
        data["ip"] = this.ip;
        data["method"] = this.method;
        data["nc"] = this.nc;
        data["nonce"] = this.nonce;
        data["qop"] = this.qop;
        data["realm"] = this.realm;
        data["response"] = this.response;
        data["uri"] = this.uri;
        data["username"] = this.username;
        return data; 
    }
}

export interface IWebDavLogin {
    cnonce: string | undefined;
    ip: string | undefined;
    method: string | undefined;
    nc: string | undefined;
    nonce: string | undefined;
    qop: string | undefined;
    realm: string | undefined;
    response: string | undefined;
    uri: string | undefined;
    username: string | undefined;
}

export enum ModelAndViewStatus {
    CONTINUE = "CONTINUE", 
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS", 
    PROCESSING = "PROCESSING", 
    CHECKPOINT = "CHECKPOINT", 
    OK = "OK", 
    CREATED = "CREATED", 
    ACCEPTED = "ACCEPTED", 
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION", 
    NO_CONTENT = "NO_CONTENT", 
    RESET_CONTENT = "RESET_CONTENT", 
    PARTIAL_CONTENT = "PARTIAL_CONTENT", 
    MULTI_STATUS = "MULTI_STATUS", 
    ALREADY_REPORTED = "ALREADY_REPORTED", 
    IM_USED = "IM_USED", 
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES", 
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY", 
    FOUND = "FOUND", 
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY", 
    SEE_OTHER = "SEE_OTHER", 
    NOT_MODIFIED = "NOT_MODIFIED", 
    USE_PROXY = "USE_PROXY", 
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT", 
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT", 
    BAD_REQUEST = "BAD_REQUEST", 
    UNAUTHORIZED = "UNAUTHORIZED", 
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED", 
    FORBIDDEN = "FORBIDDEN", 
    NOT_FOUND = "NOT_FOUND", 
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED", 
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE", 
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED", 
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT", 
    CONFLICT = "CONFLICT", 
    GONE = "GONE", 
    LENGTH_REQUIRED = "LENGTH_REQUIRED", 
    PRECONDITION_FAILED = "PRECONDITION_FAILED", 
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE", 
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE", 
    URI_TOO_LONG = "URI_TOO_LONG", 
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG", 
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE", 
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE", 
    EXPECTATION_FAILED = "EXPECTATION_FAILED", 
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT", 
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE", 
    METHOD_FAILURE = "METHOD_FAILURE", 
    DESTINATION_LOCKED = "DESTINATION_LOCKED", 
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY", 
    LOCKED = "LOCKED", 
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY", 
    TOO_EARLY = "TOO_EARLY", 
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED", 
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED", 
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", 
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE", 
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS", 
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR", 
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED", 
    BAD_GATEWAY = "BAD_GATEWAY", 
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE", 
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT", 
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED", 
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES", 
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE", 
    LOOP_DETECTED = "LOOP_DETECTED", 
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED", 
    NOT_EXTENDED = "NOT_EXTENDED", 
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED", 
}